import { ChandelierIcon } from './ChandelierIcon';

/**
 * author: Michael Irigoyen
 * id C0F0A8D1-34A5-462C-B417-733507042380
 * name chandelier
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chandelier.svg
 * tags
 * - Home Automation 
 */
export const SuspendedLightIcon = ChandelierIcon;
export default SuspendedLightIcon